import React from 'react';
import classNames from 'classnames';

import { SimpleDropdownProps } from '@/components/dropdown/types';

const SimpleDropdown = ({
	expanded = false,
	headerIcon,
	placeholder,
	selectedValue,
	showHeaderIcon = false,
	toggleDropdown,
	filter = false,
	color,
	withSelectedStyles,
	disabled,
	onClearAll,
	clearAll,
	coverFull,
}: SimpleDropdownProps) => (
	<div
		className={classNames('dropdown-simple', {
			selected: filter,
			'light-gray': color === 'gray',
			'selected-styling': withSelectedStyles,
			'cover-full': !!coverFull,
			disabled,
		})}
		onClick={toggleDropdown}
	>
		{showHeaderIcon && headerIcon && (
			<span className={classNames('icon', headerIcon, 'left-icon')} />
		)}
		<span className={classNames('title', !selectedValue && 'placeholder')}>
			{selectedValue || placeholder}
		</span>
		<span className={classNames('icon', 'icon-chevron-down', 'right-icon', { expanded })} />
		{clearAll && <span onClick={onClearAll} className="icon icon-close" />}
	</div>
);

export default SimpleDropdown;
